<template>
  <v-container fluid class="px-8">
    <v-card>
      <v-card-text class="pb-0">
        <v-container fluid>
          <div class="d-flex justify-end">
            <v-btn
              class="mt-4 mr-4"
              color="primary"
              fab
              small
            >
              <v-icon @click="userFormEnabled = !userFormEnabled">
                mdi-plus
              </v-icon>
            </v-btn>
          </div>

          <core-main-table
            :headers="headers"
            :items="users"
            @menu-click="menuClick"
          >
            <template v-slot:item.roleIds="props">
              <v-chip
                v-for="(roleId, index) in props.item.roleIds"
                :key="index"
                class="ma-1 ml-0"
                :disabled="getRoleInactive(roleId)"
                small
              >
                {{ getRoleName(roleId) }}
              </v-chip>
            </template>
            <template v-slot:item.data-table-menu="props">
              <v-menu
                offset-y
                left
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <template v-for="(item, index) in menuItems">
                    <v-list-item
                      v-if=" !hideItem(item.value,props.item)"
                      :key="index"
                      link
                      @click="menuClick(item.value, props.item)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-menu>
            </template>
          </core-main-table>

          <v-dialog
            v-model="userFormEnabled"
            width="50%"
            @click:outside="userData={}"
          >
            <form-user
              v-model="userData"
              :loading="loading"
              @save="updateUser"
            />
          </v-dialog>

          <v-dialog
            v-model="deleteUserBoxEnabled"
            persistent
            width="40%"
          >
            <v-card>
              <v-card-title class="headline">
                Confirm user deletion
              </v-card-title>
              <v-card-text>{{ userDeleteConfirmationMessage }} </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="green darken-1" text @click="clearDeletionData()">
                  Cancel
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  :disabled="isDeleting"
                  :loading="isDeleting"
                  @click="deleteUser()"
                >
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import usersMixins from '../../mixins/users';
import AuthMixin from '../../mixins/auth';
import RolesMixin from '../../mixins/roles';
import UpdateEntityMixin from '../../mixins/update-entity';
import headers from '../../headers';
import { LEVEL } from '../../utils/log';


export default {
  mixins: [
    usersMixins,
    AuthMixin,
    RolesMixin,
    UpdateEntityMixin,
  ],

  data: () => ({
    userRight: '',

    rights: [
      'Admin',
      'Non admin',
    ],

    userFormEnabled: false,

    userData: {},
    // deletion data
    deleteUserBoxEnabled: false,
    userToDelete: {},
    userDeleteConfirmationMessage: '',
    loading: false,
    isDeleting: false,

    menuItems: [
      { label: 'Delete', value: 'delete' },
      { label: 'Edit', value: 'edit' },
    ],
    entity: {}
  }),

  computed: {
    ...mapGetters('contacts', {
      findContacts: 'find'
    }),

    headers() {
      return [
        {
          text: '',
          value: 'email',
          gravatar: true,
          noTooltip: true,
        },
        {
          text: this.$t('common.name'),
          value: 'displayName',
        },
        {
          text: this.$t('form.user.fields.email'),
          value: 'email',
        },
        ...headers.updated.call(this),
        {
          text: this.$t('form.user.fields.roles'),
          value: 'roleIds',
          hidden: async () => !(await this.isAdmin),
        },
        {
          text: '',
          value: 'data-table-menu',
          items: this.menuItems,
        },
      ];
    },
  },

  mounted() {
    this.fetchRoles({ query: {} });
    // TODO fetch user by compagny
    this.fetchUsers({ query: {} });
  },

  methods: {
    ...mapActions('app', [
      'toggleLocale',
      'pushSnack'
    ]),
    ...mapActions('contacts', {
      fetchContacts: 'find'
    }),

    async updateUser(user) {
      this.loading = true;
      const { User } = this.$FeathersVuex.api;
      const newUser = new User(user);
      // TODO make sure that there is at least one administrator in each compagny
      await this.updateEntity(undefined, newUser);
      // refresh contacts store
      this.fetchContacts();
      this.userFormEnabled = false;
      this.loading = false;
      this.userData = {};
    },

    menuClick(menu, entity) {
      if (menu === 'delete') {
        if (!this.hasAdminRole(entity.roleIds)) {
          // if user does not have and admin role, popup the confirmation message before delete the user
          this.userToDelete = entity;
          this.userDeleteConfirmationMessage = `are you sure you want to delete user ${this.userToDelete.displayName}?`;
          this.deleteUserBoxEnabled = true;
        } else {
          // get the user role
          const userRoles = this.findRoles({ query: { _id: { $in: entity.roleIds } } }).data;
          // get the admin role id the user has an admin role
          const adminRole = userRoles.find(role => _.isEqual(role.name, 'Administrator'));
          // TODO get admin user list from store by company
          const adminUsers = this.findUsers({ query: {
            roleIds: adminRole._id
          } }).data;
          // check if the user is the last one with the admin role
          const othersAdminUsers = adminUsers.find(user => user._id !== entity._id);
          if (!othersAdminUsers) {
            this.isLastAdmin = true;
            this.userToDelete = entity;
            // TODO don't show delete option when there is only one admin
            // if yes popup an error message: can not delete this user
            this.pushSnack({
              snack: { message: `Error: ${this.userToDelete.displayName} is the only administrator in the compagny` },
              level: LEVEL.ERROR,
            });
            this.clearDeletionData();
          } else {
            // if no popup a confirmation message
            this.userToDelete = entity.clone();
            this.userDeleteConfirmationMessage = `are you sure you want to delete user ${this.userToDelete.displayName}?`;
            this.deleteUserBoxEnabled = true;
          }
        }
      } else if (menu === 'edit') {
        // call update user
        this.userData = entity.clone();
        this.userFormEnabled = true;
      }
    },

    async deleteUser() {
      this.isDeleting = true;
      // find contact
      // const contact = this.findContacts({ query: { ContactEmail: this.userToDelete.email } }).data;
      // await this.removeUser(`${this.userToDelete._id}_${_.get(contact[0], '_id', '')}`);
      await this.userToDelete.remove();
      this.pushSnack({
        snack: { message: 'User deleted' },
        level: LEVEL.SUCCESS,
      });
      this.isDeleting = false;
      this.clearDeletionData();
    },

    clearDeletionData() {
      this.deleteUserBoxEnabled = false;
      this.userDeleteConfirmationMessage = '';
      this.userToDelete = {};
    },

    hasAdminRole(roleIds) {
      // get the user role
      const userRoles = this.findRoles({ query: { _id: { $in: roleIds } } }).data;
      // check if the user has an admin role
      const adminRole = userRoles.find(role => _.isEqual(role.name, 'Administrator'));
      return !!adminRole;
    },

    isLastAdmin(userId) {
      const adminRoleId = this.findRoles({ query: { name: 'Administrator' } }).data;
      const adminUsers = this.findUsers({ query: {
        roleIds: adminRoleId[0]._id
      } }).data;
      // check if the user is the last one with the admin role
      const othersAdminUsers = adminUsers.find(user => user._id !== userId);
      return !othersAdminUsers;
    },

    hideItem(menuItem, entity) {
      if ((menuItem === 'delete') && (this.hasAdminRole(entity.roleIds)) && (this.isLastAdmin(entity._id))) {
        return true;
      }
      return false;
    }
  },
};
</script>
